import script from "./ExamSummarize.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamSummarize.vue?vue&type=script&setup=true&lang=ts"

import "./ExamSummarize.vue?vue&type=style&index=0&id=019f496a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019f496a"]])

export default __exports__